import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const aiSurveyCreateRoute: InvariantJiraRoute = {
	path: '/jira/servicedesk/ai-create-survey',
	name: 'ai-survey-create',
	exact: true,
	query: ['parentProduct', 'conversationChannelId', 'projectId', 'theme?', 'messageId?'],
};
